import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import IconEstado from "../../../autorizaciones/UI/IconEstado";
import InfoHistorialIcon from "../../../autorizaciones/UI/InfoHistorialIcon";
import { AREAS_FISICAS, RECLAMOS_ESTADOS } from "../../../../utils/constants";
import { ModalTrackingReclamos } from "../ModalTrackingReclamos";
import { ModalComentariosReclamos } from "../ModalGestionReclamos/ModalComentariosReclamos";
import { postTomarReclamo, setSolicitudReclamo } from "../../../../actions/reclamos/reclamosActions";
import { ModalDetalleReclamos } from "../ModalGestionReclamos/ModalDetalleReclamos";
import { CambioEstado } from "../ModalIngresoReclamo/CambioEstado"
import { CambioCategoria } from "./CambioCategoria";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ReclamoItem = (props) => {
  const classes = useRowStyles();
  const dispatch = useDispatch();
  const { item, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin } = props;
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalCambioEstado, setOpenModalCambioEstado] = useState(false);
  const [openModalCambioCategoria, setOpenModalCambioCategoria] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] =
    useState(false);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);
  const { idUsuario } = useSelector((state) => state.auth);

  const disabled =
    item?.estado === RECLAMOS_ESTADOS.FINALIZADA ||
    item?.estado === RECLAMOS_ESTADOS.ANULADA;


  // useEffect(() => {
  //   debugger
  //   if (
  //     openModalAuditar 
  //     &&
  //     !reclamosTomadosUsuario.some(
  //       (rec) =>
  //         rec.idUsuarioTomada === idUsuario &&
  //         rec.fechaLiberada === null &&
  //         rec.idReclamo === item.id
  //     )
  //   ) {
  //     if (item.idUsuarioTomada > 0 || reclamosTomadosUsuario.filter((item) => item.idUsuarioTomada === idUsuario && item.fechaLiberada === null).length === 0) {
  //       dispatch(postTomarReclamo(item, setOpenModalAuditar));
  //       props.location.state = {};
  //     } else if (reclamosTomadosUsuario.filter((item) => item.idUsuarioTomada === idUsuario && item.fechaLiberada === null).length > 0) {
  //       setOpenAlert(true);
  //     };
  //   }
  // }, [dispatch, openModalAuditar, reclamosTomadosUsuario]);

  // const handleCloseAlert = () => {
  //   setOpenAlert(false);
  //   setOpenModalAuditar(false);
    
  // };
  // const handleLiberar = () => {
  //   dispatch(putLiberarReclamo(reclamosTomadosUsuario[0]?.id, type, reclamosTomadosUsuario[0]?.idReclamo));
  //   setOpenAlert(false);
  //   setActualizar(true);
  // };


  return (
    <>
      {/* {openAlert && (
        <Dialog
          open={openAlert}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography
                style={{ color: "#222" }}
              >
                Actualmente tiene un reclamo tomado, desea liberarla para tomar el reclamo N°{item.id}?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseAlert}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleLiberar}
              variant="contained"
              color="primary"
              autoFocus
            >
              Liberar
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {openModalAuditar && (
        <ModalComentariosReclamos
          disabled={disabled}
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          solicitud={item}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
        />
      )}
      {openModalInfo && (
        <ModalTrackingReclamos
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
        />
      )}
      {openModalHistorialCambios && (
        <ModalDetalleReclamos
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          solicitud={item}
          disabled={true}
        />
      )}
      {openModalCambioEstado && (
        <CambioEstado
          open={openModalCambioEstado}
          closeModalHandler={() => {
            setOpenModalCambioEstado(false);
          }}
          solicitud={item}
          disabled={false}
          estadoSolicitudes={estadoSolicitudes}
          areasFisicasUsuario={areasFisicasUsuario}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
        />
      )}
      {openModalCambioCategoria && (
        <CambioCategoria
          open={openModalCambioCategoria}
          closeModalHandler={() => {
            setOpenModalCambioCategoria(false);
          }}
          solicitud={item}
          disabled={false}
          estadoSolicitudes={estadoSolicitudes}
          areasFisicasUsuario={areasFisicasUsuario}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
        />
      )}
      <TableRow className={classes.root}>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <InfoHistorialIcon
            onClick={() => {
              setOpenModalInfo(true);
              setIdClave(item?.id);
              setDescripcion(`${item?.descripcionAfiliado}`);
            }}
          />
        </TableCell>
        <TableCell disabled={true}
          align="center"
          onClick={() => {
            if (areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES) {
              setOpenModalCambioEstado(true);
              dispatch(setSolicitudReclamo(item));
            }
          }}
          style={{ cursor: 'pointer' }}>
          <IconEstado
            useColorTable={true}
            texto={item?.letraUrgente}
            backgroundColor={item?.colorUrgente}
            descripcion={item?.descripcionUrgente}

          />
        </TableCell>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={item?.letraEstado}
            backgroundColor={item?.color}
            descripcion={item?.descripcionEstado}
          />
        </TableCell>
        <TableCell align="left">
          {new Date(item?.fechaCarga).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{item?.id}</TableCell>
        <TableCell align="left">{item?.carnet}</TableCell>
        <TableCell align="left">{item?.descripcionAfiliado} </TableCell>
        <TableCell align="left">{item?.descripcionTipoReclamo}</TableCell>
        <TableCell align="left">{item?.descripcionTipoOrigen}</TableCell>
        <TableCell align="left" onClick={() => {
          if (areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES) {
            setOpenModalCambioCategoria(true);
            dispatch(setSolicitudReclamo(item));
          }
        }}>
          {item?.descripcionCategoriaReclamo}
        </TableCell>
        <TableCell align="left">{item?.descripcionSeccional}</TableCell>
        {/* <TableCell align="left">{item?.descripcionUsuarioCarga}</TableCell> */}
        <TableCell align="left">{item?.derivado}</TableCell>
        <TableCell align="left">{item?.subDerivado}</TableCell>
        {/* <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell> */}

        {item?.estado === RECLAMOS_ESTADOS.FINALIZADA && (
          <TableCell >
            {item?.descripcionTipoErrorReclamo}
          </TableCell>
        )}
        <TableCell align="left">
          {item?.descripcionUsuarioTomado}
        </TableCell>

        <TableCell>
          {item?.estado === RECLAMOS_ESTADOS.PENDIENTE && (
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              disabled={
                item?.idUsuarioTomada === idUsuario ? false : item?.idUsuarioTomada === 0 ? false : true
              }
              onClick={() => {
                //setOpenModalAuditar(true);
                dispatch(postTomarReclamo(item, setOpenModalAuditar));
                dispatch(setSolicitudReclamo(item));
              }}
            >
              Abrir
            </Button>
          )}
          {(item?.estado === RECLAMOS_ESTADOS.ANULADA ||
            item?.estado === RECLAMOS_ESTADOS.FINALIZADA) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenModalHistorialCambios(true);
                  dispatch(setSolicitudReclamo(item));
                }}
              >
                Abrir
              </Button>
            )}
        </TableCell>
      </TableRow>
    </>
  );
};
